import { useState, useEffect, Suspense } from 'react';
import { MIN_PARENT_ASSET_LOADING_THRESHOLD } from './loadNavigationApps/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function DeferAsyncComponentLoading({
  children,
  fallback,
  loadTimeout = MIN_PARENT_ASSET_LOADING_THRESHOLD
}) {
  const [loadComponent, setLoadComponent] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      clearTimeout(timeoutId);
      setLoadComponent(true);
    }, loadTimeout);
    return () => clearTimeout(timeoutId);
  }, [loadTimeout]);
  if (!loadComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: fallback,
    children: children
  });
}